import { isSyntheticEmail } from "@garimpa/lib/isSyntheticEmail";

interface EmailVerificationUser {
  id?: string | null;
  email?: string | null;
  emailVerified?: boolean | null;
}

export interface EmailVerificationTarget {
  email: string;
  userId: string;
}

export function emailVerificationTarget(
  user: EmailVerificationUser | null | undefined,
): EmailVerificationTarget | null {
  if (!user?.email || isSyntheticEmail(user.email) || user.emailVerified !== false) return null;
  return { email: user.email, userId: user.id ?? user.email };
}
